import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3dd77baa&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=3dd77baa&prod&lang=scss&scoped=true&"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=3dd77baa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd77baa",
  null
  
)

export default component.exports